/** @jsx jsx */
import { css, jsx, useTheme } from '@emotion/react';

import { useLocation } from 'js/lib/useRouter';

import { useComponentsConfig } from 'bundles/page-config-common/contexts/ComponentsConfigContext';
import TrackedDiv from 'bundles/page/components/TrackedDiv';
import SearchComponentsConfigRenderer from 'bundles/search-common/components/SearchComponentsConfigRenderer';
import { isSearchTheme } from 'bundles/search-common/searchTheme';
import EntityPageCanonicalTagWrapper from 'bundles/seo-entity-page/components/EntityPageCanonicalTagWrapper';

const styles = {
  wrapper: css`
    padding-bottom: var(--cds-spacing-400);
  `,
};

const SeoSearchPageRootContent = () => {
  const pageConfigComponents = useComponentsConfig();
  const theme = useTheme();
  const location = useLocation();

  if (!isSearchTheme(theme)) {
    throw new Error(
      'SEOEntityPage can only be used in the context of a SearchTheme. Wrap this component with a ThemeProvider.'
    );
  }

  return (
    <main data-testid="search-page" id="main">
      <TrackedDiv
        className="rc-SEOEntityPage"
        trackingName="seo_entity_page"
        trackClicks={false}
        requireFullyVisible={false}
        withVisibilityTracking={true}
        atMostOnce
        data={{ searchQuery: location.query }}
        css={styles.wrapper}
        data-testid="seo-search-page-root-content"
      >
        <EntityPageCanonicalTagWrapper query={location.query} pathname={location.pathname} />
        <SearchComponentsConfigRenderer pageConfigComponents={pageConfigComponents} />
      </TrackedDiv>
    </main>
  );
};

export default SeoSearchPageRootContent;
